import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const UserDetailModule = {
  namespaced: true,

  state: {
    user_detail: {
      portrait_url: undefined,
      social_urls: {
        supplemental: []
      }
    }
  },

  actions: {
    async getUserDetails ({ commit, state }, id) {
      commit('LoaderModule/setLoaders', {
        'gettingUserDetails': true
      }, { root: true })

      await PaApi().get(
        `/admin/users/${id}/user_details`
      ).then((resp) => {
        if (resp.data.data) {
          commit('storeUserDetails', resp)

          return resp
        }
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'gettingUserDetails': false
        }, { root: true })
      })
    },

    async setUserDetails ({ commit, state }, id) {
      commit('LoaderModule/setLoaders', {
        'settingUserDetails': true
      }, { root: true })

      const formData = new FormData()
      Object.keys(state.user_detail).forEach(key => {
        let val = state.user_detail[key]
        // Don't allow for null values.
        if (val === null) {
          val = ''
        }

        if (typeof val !== 'object' || val instanceof File) {
          formData.append(
            `user[user_detail_attributes][${key}]`,
            val
          )
        } else {
          Object.keys(state.user_detail[key]).forEach(detailKey => {
            const detailVal = state.user_detail[key][detailKey]
            formData.append(
              `user[user_detail_attributes][${key}][${detailKey}]`,
              detailVal
            )
          })
        }
      })

      await PaApi().post(
        `/admin/users/${id}/user_details`, formData
      ).then((resp) => {
        commit('storeUserDetails', resp)

        return resp
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'settingUserDetails': false
        }, { root: true })
      })
    },

    storeUserDetailPortrait ({ commit, state }, portrait) {
      state.user_detail.portrait = portrait
    },

    storeUserDetails ({ commit, state }, userDetail) {
      state.user_detail = userDetail
      state.user_detail.full_portrait_url = PaApi().defaults.baseURL + userDetail.portrait_url
    }
  },

  mutations: {
    storeUserDetails (state, payload) {
      baseOpts.recursive = true
      state.user_detail = processSuccess(payload, baseOpts)

      state.user_detail.full_portrait_url = PaApi().defaults.baseURL + state.user_detail.portrait_url
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/UserDetailModule.js